import React from "react";
import "./ButtonsWarapper.css";
function ButtonsWrapper({ onSubmit, onCancel, disabled }) {
  return (
    <div className="btn-wrapper">
      <button disabled={disabled} onClick={onCancel} type="button"  className="btn btn-back-w ">
        Retour
      </button>
      <button onClick={onSubmit} type="button" id="confirmation" className="btn btn-valid-w">
        Confirmer
      </button>
    </div>
  );
}

export default ButtonsWrapper;
